import { Platform } from 'react-native';

let analyticsReady = false;

/**
 * Bootstraps native Firebase Analytics on iOS/Android.
 * No-op on web (use firebase-js there if needed).
 */
export async function initFirebaseAnalytics(): Promise<void> {
	if (analyticsReady || Platform.OS === 'web') {
		return;
	}

	try {
		const analytics = (await import('@react-native-firebase/analytics')).default;
		await analytics().setAnalyticsCollectionEnabled(true);
		await analytics().logAppOpen();
		analyticsReady = true;
		if (__DEV__) {
			console.log('[FirebaseAnalytics] collection enabled');
		}
	} catch (error) {
		console.warn('[FirebaseAnalytics] init failed:', error);
	}
}

export async function logFirebaseEvent(
	name: string,
	params?: Record<string, string | number | boolean>,
): Promise<void> {
	if (Platform.OS === 'web') {
		return;
	}

	try {
		const analytics = (await import('@react-native-firebase/analytics')).default;
		await analytics().logEvent(name, params);
	} catch (error) {
		if (__DEV__) {
			console.warn('[FirebaseAnalytics] logEvent failed:', name, error);
		}
	}
}
